import axios from 'axios';

export const AuthAPI = axios.create({
	baseURL: process.env.REACT_APP_AUTH_API,
	timeout: 30000,
});

export default AuthAPI;